import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges } from '@angular/core';

import { debounceTime } from 'rxjs/operators';

import uuid from '../../../../utils/uuid';
import { FormService } from '../../../../api/form.service';
import { Countries } from '../../../../utils/countries-enum';

@Component({
  selector: 'iv-gst-fee',
  templateUrl: './gst-fee.component.html',
  styleUrls: ['./gst-fee.component.scss']
})
export class GstFeeComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  gstRates;

  @Input()
  selectedGSTRate;

  @Input()
  disabled = false;

  @Output()
  gstFeeChanged;

  $gstFee;
  uuid = uuid();
  gstFeeForm;
  @Input() userCountry = '';
  showAsterisk = true;
  constructor(private fb: UntypedFormBuilder,
    private formService: FormService) {
    this.gstFeeChanged = new EventEmitter();
  }

  ngOnInit() {
    this.showMandatory();
    this.setupForm();
  }

  setupForm() {
    this.gstFeeForm = this.fb.group({
      selectedGSTRate: [{
        value: this.selectedGSTRate,
        disabled: this.disableGSTFeeByCountry() || (this.disabled === true && this.disabled)
      }, Validators.required],
    });
    this.formService.addLoadedForm(this.gstFeeForm, this.uuid);

    if (this.$gstFee) {
      this.$gstFee.unsubscribe();
    }
    this.$gstFee = this.gstFeeForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe(changes => {
        this.gstFeeChanged.emit(changes);
      });
  }
  ngOnChanges() {
    this.setupForm();
  }
  disableGSTFeeByCountry() {
    let disableGST = false;
    switch (this.userCountry) {
      case Countries.China:
      case Countries.Hongkong:
        disableGST = true;
        break;
      default: break;
    }
    return disableGST;
  }
  showMandatory() {
    switch (this.userCountry) {
      case Countries.China:
      case Countries.Hongkong:
      case Countries.Taiwan:
        this.showAsterisk = false;
        break;
      default:
        this.showAsterisk = true;
        break;
    }
  }
  getGSTLabel() {
    return this.formService.getGSTLabel();
  }
  ngOnDestroy() {
    if (this.$gstFee) {
      this.$gstFee.unsubscribe();
    }
  }
}
